import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEdit, faUserLock, faSignInAlt, faArrowUp, faArrowDown, faEnvelope, faCalendarAlt, faEye, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import loading from "../Dashboard/assets/img/loading.gif";
import Dialog from 'react-dialog';
import { userloginDetails } from '../Utils/AdminAuth';
import DatePicker from "react-datepicker";
import { userId } from '../Utils/userAuth';
import UserDetails from './UserDetails';
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';
import { FaSms } from 'react-icons/fa';
import RcsImage from "../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import microphoneIcon from "../Dashboard/assets/img/microphone.png";
import emailImage from "../Dashboard/assets/img/email-icon.png";
import ReactDatePicker from "react-datepicker";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import Spining from '../UI/Spining/Spining';
import { handleUserLog } from '../Utils/Utils';

class UserManagement extends Component {

    constructor() {

        const lStorage = userloginDetails();


        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        const isAdmin = lStorage?.user?.isAdmin;
        const AdminEmail = lStorage.user.username;
        const userPassword = lStorage.user.password;
        const today = new Date().toISOString().split("T")[0];
        super();

        this.state = {
            user_id: userId,
            adminPassword: userPassword,
            AdminEmail: AdminEmail,
            token: userToken,
            userType: isAdmin,
            allUserList: null,
            allUserListDetails: null,
            isactive: '',
            selectedUserId: '',
            searchData: '',
            isDialogOpen: false,
            userCurrentStatus: '',
            successMessage: false,
            errorMessage: '',
            bgColor: '',
            dateFrom: today,
            dateTo: today,
            count: {},
            signupDetails: [],
            email: [],
            rcs: [],
            sms: [],
            voice: [],
            wpNotOnboarding: [],
            wpOnboarding: [],
            pendingonboarding: [],
            completeonboarding: [],
            rcsPending: [],
            rcsApproved: [],
            rcsInProcess: [],
            rcsRejected: [],
            rcsPendingPercentage: 0,
            rcsApprovedPercentage: 0,
            rcsInProcessPercentage: 0,
            rcsRejectedPercentage: 0,
            rcsPendingList: false,
            rcsApprovedList: true,
            rcsInProcessList: false,
            rcsRejectedList: false,
            pendingPercentage: 0,
            completedPercentage: 0,
            pendingPercentageList: false,
            completedPercentageList: true,
            fromDate: "", // default today
            toDate: "",
            userSearchFromDate: "",// default today
            userSearchToDate: "",
            onboardingData: [],
            onboardingfilterstate: [],
            rcsonboardinglist: [],
            rcsonboardinglistdisplay: [],
            showSignupDetails: false,
            showRcsOnboardingDetails: true,
            showWhatsappOnboardingDetails: false,
            staffCount: [],
            webCount: [],
            staffPercentage: 0,
            webPercentage: 0,
            staffPercentageList: true,
            webPercentageList: false,
            gmailPercentageList: false,
            activeTab: "domain",
            gmailPrecentage: 0,
            gmail: [],
            totalRecords: 0,
            loading: false,
            mmliteChecked: false,
            ip: "0.0.0.0",
            activeTooltipId: null
        }

    }

    handleMmliteChange = (event) => {
        this.setState({ mmliteChecked: event.target.checked });
    };

    getFormattedDate(date) {
        const d = new Date(date); // ensure it's a Date object
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }


    componentDidMount() {
        this.onserch();
        this.showData();
        this.onboardingList();
        this.fetchRcsOnboardingList();
        this.dashboardInfo();
        this.getUserIP();
    }

    getUserIP = () => {
        fetch("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => {
                this.setState({ ip: data?.ip ? data.ip : "0.0.0.0" });
            })
            .catch((err) => {
                console.error("Error fetching IP:", err);
                this.setState({ ip: "0.0.0.0" });
            });
    };

    onboardingList = async () => {
        try {
            const payload = {
                user_id: this.state.user_id,
                method: "retrieve_whatsapp_user",
                type: this.state.userType,
                token: this.state.token,
            };

            let { data } = await Axios.post(
                `${HOST_URL}/admin_user_list.php`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (data.success) {
                const todayWhatsapp = new Date();
                const todayDateWhatspp = todayWhatsapp.toISOString().split("T")[0];

                let todayWhatsappData = data.data.filter((x) => {
                    const createdDateWhatsapp = new Date(x.created).toISOString().split("T")[0];
                    return createdDateWhatsapp === todayDateWhatspp;
                });

                let pendingData = todayWhatsappData.filter((x) => x.status === 0);
                let completeData = todayWhatsappData.filter((x) => x.status === 1);

                let pendingPercentageData = (pendingData.length / data.data.length) * 100;
                let completedPercentageData = (completeData.length / data.data.length) * 100;

                this.setState({
                    onboardingfilterstate: todayWhatsappData,
                    onboardingData: data.data,
                    pendingonboarding: pendingData,
                    completeonboarding: completeData,
                    pendingPercentage: pendingPercentageData,
                    completedPercentage: completedPercentageData,
                });
            } else {
                // console.log(data)
            }
        } catch (error) {
            console.log(error);
        }
    };



    fetchRcsOnboardingList = async () => {
        try {
            const dataForList = {
                user_id: this.state.user_id,
                token: this.state.token,
                method: "onboarding_request",
            };
            const { data } = await Axios.post(
                `${NODE_HOST_URL}/admin/rcs`,
                dataForList
            );
            if (data.success === true) {
                const today = new Date();
                const todayDateStr = today.toISOString().split('T')[0];
                let todayrcsData = data.data.filter(x => {
                    const createdDateStr = new Date(x.created_date).toISOString().split('T')[0];
                    return createdDateStr === todayDateStr;
                });
                let filterApproved = todayrcsData.filter(x => x.status === 1)
                let filterRejected = todayrcsData.filter(x => x.status === 3)
                let filterInProcess = todayrcsData.filter(x => x.status === 2)
                let filterPending = todayrcsData.filter(x => x.status === 0)
                let approveDataPercent = filterApproved.length / data.data.length * 100
                let rejectedDataPercent = filterRejected.length / data.data.length * 100
                let inprocessDataPercent = filterInProcess.length / data.data.length * 100
                let pendingDataPercent = filterPending.length / data.data.length * 100
                this.setState({
                    rcsonboardinglist: data.data,
                    rcsonboardinglistdisplay: todayrcsData,
                    rcsPending: filterPending,
                    rcsApproved: filterApproved,
                    rcsInProcess: filterInProcess,
                    rcsRejected: filterRejected,
                    rcsPendingPercentage: pendingDataPercent,
                    rcsApprovedPercentage: approveDataPercent,
                    rcsInProcessPercentage: inprocessDataPercent,
                    rcsRejectedPercentage: rejectedDataPercent,
                })
            }
        } catch (error) {
            console.log(error.message);
        }
    };



    showData = async () => {
        const date = new Date();

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        const dateStr = `${year}/${month}/${day}`;

        const frmdt = this.state.dateFrom ? this.state.dateFrom : dateStr;
        const todt = this.state.dateTo ? this.state.dateTo : dateStr;

        try {
            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, {
                user_id: this.state.user_id,
                method: "admin_signup_count",
                type: this.state.userType,
                token: this.state.token,
                date_from: frmdt,
                date_to: todt,
            });

            if (data) {
                this.setState({ count: data });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    onserch = async () => {
        this.setState({ loading: true })
        try {
            const payload = {
                user_id: this.state.user_id,
                method: "retrieve",
                type: this.state.userType,
                token: this.state.token,
            };

            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
                headers: { "Content-Type": "application/json" },
            });

            // console.log(data)

            if (data.success) {
                this.setState({
                    allUserList: data.data,
                    allUserListDetails: data.data,
                    userCurrentStatus: data.data[0]?.is_active,
                    totalRecords: data.total_record_found,
                    loading: false
                });
            } else {
                this.setState({
                    successMessage: true,
                    bgColor: "alert alert-danger",
                    errorMessage: data.message,
                });
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false })
        }
    };

    searchUser = async () => {
        this.setState({ loading: true });
        // if (this.state.userSearchFromDate === "") {
        //     this.setState({
        //         successMessage: true,
        //         errorMessage: " ",
        //         bgColor: "alert alert-danger alert-dismissible",
        //     });
        // }
        try {
            const payload = {
                user_id: this.state.user_id,
                method: "retrieve",
                type: "search",
                user_name: this.state.searchData.trim(),
                token: this.state.token,
                fromDate: this.state.userSearchFromDate ? this.getFormattedDate(this.state.userSearchFromDate) : "",
                toDate: this.state.userSearchToDate ? this.getFormattedDate(this.state.userSearchToDate) : "",
                mmlite: this.state.mmliteChecked ? 1 : 0
            };

            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
                headers: { "Content-Type": "application/json" },
            });

            if (data.success) {
                this.setState({
                    successMessage: false,
                    allUserList: data.data,
                    totalRecords: data?.total_record_found ? data.total_record_found : 0
                });
            } else {
                this.setState({
                    successMessage: true,
                    errorMessage: data.message,
                    allUserList: null,
                    bgColor: "alert alert-danger alert-dismissible",
                });
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false })
        }

    };

    userDisabled = async () => {
        document.querySelector("body").scrollTo(0, 0);

        try {
            const payload = {
                user_id: this.state.user_id,
                method: "enabledisable",
                current_status: this.state.isactive ? "1" : "0",
                ret_user_id: this.state.selectedUserId,
                token: this.state.token,
            };

            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
                headers: { "Content-Type": "application/json" },
            });

            if (data.success) {
                this.setState({
                    successMessage: true,
                    successBg: "alert alert-success alert-dismissible",
                    errorMessage: data.message,
                });
                window.location.reload();
            } else {
                this.setState({
                    successMessage: true,
                    successBg: "alert alert-danger alert-dismissible",
                    errorMessage: data.message,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };


    loginToUserAccount(emailaddress, password) {
        var url = document.location.href;
        const singleTemplateData = ({ username: emailaddress, password: password, admintype: this.state.userType });
        fetch(`${HOST_URL}/login.php`, {
            method: "post",
            headers: {
                'content-Type': 'application/json'
            },
            body: JSON.stringify(singleTemplateData)
        }).then((result) => {
            result.json().then((result) => {
                if (result.success === true) {
                    result['url'] = url;
                    result['ip'] = this.state.ip ;

                    if (result.user.userId === 8407) {
                        localStorage.setItem("stanmaxuser", JSON.stringify(result));
                        window.location = "/stanmax/whatsappconv";
                        return;
                    } else {
                        localStorage.setItem("login", JSON.stringify(result));
                        window.location = "/dashboard";
                    }
                    handleUserLog(emailaddress, "login_user", "login", "User Login Successfully", "login", "", singleTemplateData)
                } else {
                    this.setState({
                        successMessage: true,
                        bgColor: "alert alert-danger alert-dismissible",
                        errorMessage: result.message
                    })
                    handleUserLog(emailaddress, "login_user", "login", result.message, "login", "", singleTemplateData)
                }
            })
        })



    }


    openDialog = (isactive, selectedUserId) => this.setState({
        isDialogOpen: true,
        isactive: isactive,
        selectedUserId: selectedUserId,
    })

    handleClose = () => this.setState({ isDialogOpen: false })

    dateFrom = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateFrom: dated,
            SelecteddateFrom: date
        });
    };

    dateTo = (date) => {
        let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
        this.setState({
            dateTo: dated,
            SelecteddateTo: date
        });
    };

    dashboardInfo = async (from, to) => {
        const formatLocalDate = (date) => {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const today = formatLocalDate(new Date());

        let paramData = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "signup_dashboard",
            filter_type: "old",
            fromdate: from ? this.getFormattedDate(from) : "",
            todate: to ? this.getFormattedDate(to) : "",
        };

        try {
            let { data } = await Axios.post(`${NODE_HOST_URL_v1}/user_signup_dashboard`, paramData);
            if (data.success) {
                let staff = []
                let web = []
                let gmail = []
                let staffPercentage = 0
                let webPercentage = 0
                let gmailPercentage = 0
                if (this.state.userType === "admin") {
                    staff = data.signup_details.filter(x => x.added_by === "STAFF");
                    web = data.signup_details.filter(x => x.added_by === "WEB");
                    gmail = data.signup_details.filter(x => x.added_by === "VIA_GMAIL");
                    staffPercentage = staff.length / data.signup_details.length * 100;
                    webPercentage = web.length / data.signup_details.length * 100;
                    gmailPercentage = gmail.length / data.signup_details.length * 100;

                    this.setState({
                        signupDetails: data.signup_details,
                        staffCount: staff,
                        webCount: web,
                        gmail: gmail,
                        staffPercentage: staffPercentage,
                        webPercentage: webPercentage,
                        gmailPrecentage: gmailPercentage
                    });
                }
                else {
                    let filterParentData = data.signup_details.filter(x => x.parent === this.state.user_id)
                    staff = filterParentData.filter(x => x.added_by === "STAFF");
                    web = filterParentData.filter(x => x.added_by === "WEB");
                    gmail = filterParentData.filter(x => x.added_by === "VIA_GMAIL");
                    staffPercentage = staff.length / data.signup_details.length * 100;
                    webPercentage = web.length / data.signup_details.length * 100;
                    gmailPercentage = gmail.length / data.signup_details.length * 100;

                    this.setState({
                        signupDetails: filterParentData,
                        staffCount: staff,
                        webCount: web,
                        gmail: gmail,
                        staffPercentage: staffPercentage,
                        webPercentage: webPercentage,
                        gmailPrecentage: gmailPercentage
                    });
                }

            }
        } catch (error) {
            console.log(error);
        }
    };



    fromdateHandler = (date) => {
        this.setState({
            fromdate: date,
            todate: null, // reset todate when fromdate changes
        });
    };

    todateHandler = (date) => {
        this.setState({ todate: date });
    };

    tableheadColor = {
        backgroundColor: "#4ec9b0"
    }

    tabStyleSelected = {
        backgroundColor: "#4ec9b0",
        color: "white",
        borderRadius: "15px",
    }

    tabStyle = {
        backgroundColor: "white",
        color: "#4ec9b0",
        borderRadius: "15px"
    }

    dateSearch = () => {
        const from = new Date(this.state.fromDate);
        const to = new Date(this.state.toDate);
        to.setHours(23, 59, 59, 999); // Include full to-date

        let onboardingDatafull = [...this.state.onboardingfilterstate]
        let rcsonboardingdatafull = [...this.state.rcsonboardinglistdisplay]

        const filterWhatsappData = this.state.onboardingData.filter(x => {
            const createdDate = new Date(x.created);
            return createdDate >= from && createdDate <= to;
        });

        const filterRcsData = this.state.rcsonboardinglist.filter(x => {
            const createdrcsDate = new Date(x.created_date);
            return createdrcsDate >= from && createdrcsDate <= to;
        })

        let pendingData = filterWhatsappData.filter(x => x.status === 0)
        let completeData = filterWhatsappData.filter(x => x.status === 1)
        let pendingPercentageData = pendingData.length / filterWhatsappData.length * 100
        let completedPercentageData = completeData.length / filterWhatsappData.length * 100
        this.setState({ onboardingData: onboardingDatafull, pendingonboarding: pendingData, completeonboarding: completeData, pendingPercentage: pendingPercentageData, completedPercentage: completedPercentageData })

        let filterApproved = filterRcsData.filter(x => x.status === 1)
        let filterRejected = filterRcsData.filter(x => x.status === 3)
        let filterInProcess = filterRcsData.filter(x => x.status === 2)
        let filterPending = filterRcsData.filter(x => x.status === 0)
        let approveDataPercent = filterApproved.length / filterRcsData.length * 100
        let rejectedDataPercent = filterRejected.length / filterRcsData.length * 100
        let inprocessDataPercent = filterInProcess.length / filterRcsData.length * 100
        let pendingDataPercent = filterPending.length / filterRcsData.length * 100
        this.setState({
            rcsonboardinglistdisplay: rcsonboardingdatafull,
            rcsPending: filterPending,
            rcsApproved: filterApproved,
            rcsInProcess: filterInProcess,
            rcsRejected: filterRejected,
            rcsPendingPercentage: pendingDataPercent,
            rcsApprovedPercentage: approveDataPercent,
            rcsInProcessPercentage: inprocessDataPercent,
            rcsRejectedPercentage: rejectedDataPercent,
        })
        this.dashboardInfo(from, to)

        // const filterUserList = this.state.allUserListDetails.filter(x => {
        //     const createdUserDate = new Date(x.created);
        //     return createdUserDate >= from && createdUserDate <= to;
        // });

        // this.setState({ allUserList: filterUserList })
    };

    handleRcsOnboardingClick = () => {
        this.props.history.push('/admin/rcs/rcs-request-list');
    };

    handleWPOnboardingClick = () => {
        this.props.history.push('/admin/whatsapp-account-list');
    };

    handleSignupDetailsClick = () => {
        this.props.history.push('/admin/embeded-signup');
    };

    getDate30DaysBack = () => {
        const today = new Date();
        today.setDate(today.getDate() - 30); // subtract 30 days
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    render() {
        const oneDayBefore = new Date();
        oneDayBefore.setDate(oneDayBefore.getDate() - 1);
        const { fromdate, todate } = this.state;

        // If fromdate is selected, set minDate and maxDate for todate picker
        const minToDate = fromdate;
        const maxToDate = fromdate
            ? new Date(fromdate.getFullYear(), fromdate.getMonth() + 3, fromdate.getDate())
            : null;

        return (
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    {this.state.loading && <Spining />}
                    <main className="content">
                        {/* <div className="container"> */}
                        <div className="row">
                            {/* Daily Sales */}

                            {this.state.userType !== "admin" &&
                                <div className='row'>
                                    <h5 className='ml-3'>User Management</h5>
                                </div>}

                            <div className="row">
                                <div className="col-12 mb-2">
                                    <div className="row align-items-center">
                                        {/* User Management Title (Only for Admin) */}
                                        {this.state.userType === "admin" && (
                                            <div className="col-lg-4 col-md-6 col-12 mb-2">
                                                <h5 className="ml-lg-3 text-center text-lg-left">User Management</h5>
                                            </div>
                                        )}

                                        {/* From Date */}
                                        <div
                                            className={
                                                this.state.userType === "admin"
                                                    ? "col-lg-3 col-md-4 col-12 mb-2"
                                                    : "col-lg-4 col-md-6 col-12 mb-2"
                                            }
                                        >
                                            <div className="input-group">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <input
                                                    type="date"
                                                    id="fromDate"
                                                    className="form-control"
                                                    value={this.state.fromDate}
                                                    onChange={(e) => this.setState({ fromDate: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* To Date */}
                                        <div
                                            className={
                                                this.state.userType === "admin"
                                                    ? "col-lg-3 col-md-4 col-12 mb-2"
                                                    : "col-lg-4 col-md-6 col-12 mb-2"
                                            }
                                        >
                                            <div className="input-group">
                                                <div className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </div>
                                                <input
                                                    type="date"
                                                    id="toDate"
                                                    className="form-control"
                                                    value={this.state.toDate}
                                                    onChange={(e) => this.setState({ toDate: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* Search Button */}
                                        <div className="col-lg-2 col-md-4 col-12 mb-2">
                                            <button
                                                type="button"
                                                onClick={this.dateSearch}
                                                className="btn btn-info btn-sm btn-block"
                                            >
                                                Search
                                            </button>
                                        </div>

                                        {/* Add New Client (For reseller / emp only) */}
                                        {(this.state.userType === "reseller" ||
                                            this.state.userType === "emp") && (
                                                <div className="col-lg-2 col-md-4 col-12 mb-2">
                                                    <a
                                                        className="btn btn-sm btn-block"
                                                        href="/admin/add-new-client"
                                                        style={{ backgroundColor: "#4ec9b0", color: "white" }}
                                                    >
                                                        Add New Client
                                                    </a>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>


                            <div className="row g-3 mb-3">
                                {/* Signup Details Card */}
                                <div className="col-12 col-md-4">
                                    <div className="card h-100">
                                        <div className="card-header pb-0 border-bottom-0 d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">Signup Details</h5>
                                            <b style={{ color: "black" }}>{this.state.signupDetails.length}</b>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                <span
                                                    className="badge"
                                                    style={{ backgroundColor: "#4ec9b0", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ staffPercentageList: true, webPercentageList: false, gmailPercentageList: false })}
                                                >
                                                    Staff: {this.state.staffCount.length}
                                                </span>
                                                <span
                                                    className="badge ml-2"
                                                    style={{ backgroundColor: "#FF8000", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ staffPercentageList: false, webPercentageList: false, gmailPercentageList: true })}
                                                >
                                                    Via Gmail: {this.state.gmail.length}
                                                </span>
                                                <span
                                                    className="badge ml-2"
                                                    style={{ backgroundColor: "#50b5ff", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ staffPercentageList: false, webPercentageList: true, gmailPercentageList: false })}
                                                >
                                                    Web: {this.state.webCount.length}
                                                </span>
                                            </div>

                                            <div className="progress mb-2" style={{ height: '6px', borderRadius: '0.3rem' }}>
                                                <div
                                                    className={
                                                        this.state.staffPercentageList ? "progress-bar bg-primary" :
                                                            this.state.webPercentageList ? "progress-bar bg-info" :
                                                                this.state.gmailPercentageList ? "progress-bar bg-warning" : "progress-bar bg-secondary"
                                                    }
                                                    role="progressbar"
                                                    style={{
                                                        width: `${this.state.staffPercentageList ? this.state.staffPercentage :
                                                            this.state.webPercentageList ? this.state.webPercentage :
                                                                this.state.gmailPercentageList ? this.state.gmailPrecentage : 0
                                                            }%`
                                                    }}
                                                ></div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <span>
                                                    {
                                                        Number.isFinite(
                                                            parseFloat(
                                                                this.state.staffPercentageList ? this.state.staffPercentage :
                                                                    this.state.webPercentageList ? this.state.webPercentage :
                                                                        this.state.gmailPercentageList ? this.state.gmailPrecentage : 0
                                                            )
                                                        )
                                                            ? parseFloat(
                                                                this.state.staffPercentageList ? this.state.staffPercentage :
                                                                    this.state.webPercentageList ? this.state.webPercentage :
                                                                        this.state.gmailPercentageList ? this.state.gmailPrecentage : 0
                                                            ).toFixed(2)
                                                            : "0"
                                                    }%
                                                </span>

                                                {this.state.userType === "admin" && <FontAwesomeIcon onClick={this.handleSignupDetailsClick} icon={faEye} className="ms-2 ml-2" style={{ cursor: "pointer" }} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* RCS Onboarding Card */}
                                <div className="col-12 col-md-4">
                                    <div className="card h-100">
                                        <div className="card-header pb-0 border-bottom-0 d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">RCS Onboarding</h5>
                                            <b style={{ color: "black" }}>
                                                {this.state.rcsApproved.length + this.state.rcsPending.length + this.state.rcsInProcess.length + this.state.rcsRejected.length}
                                            </b>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                <span
                                                    className="badge"
                                                    style={{ backgroundColor: "#4ec9b0", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ rcsPendingList: false, rcsApprovedList: true, rcsInProcessList: false, rcsRejectedList: false })}
                                                >
                                                    Completed: {this.state.rcsApproved.length}
                                                </span>
                                                <span
                                                    className="badge ml-2"
                                                    style={{ backgroundColor: "#FF8000", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ rcsPendingList: true, rcsApprovedList: false, rcsInProcessList: false, rcsRejectedList: false })}
                                                >
                                                    Pending: {this.state.rcsPending.length}
                                                </span>
                                                <span
                                                    className="badge ml-2"
                                                    style={{ backgroundColor: "#50b5ff", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ rcsPendingList: false, rcsApprovedList: false, rcsInProcessList: true, rcsRejectedList: false })}
                                                >
                                                    In Progress: {this.state.rcsInProcess.length}
                                                </span>
                                                <span
                                                    className="badge mt-1"
                                                    style={{ backgroundColor: "#FF0000", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ rcsPendingList: false, rcsApprovedList: false, rcsInProcessList: false, rcsRejectedList: true })}
                                                >
                                                    Rejected: {this.state.rcsRejected.length}
                                                </span>
                                            </div>

                                            <div className="progress mb-2" style={{ height: '6px', borderRadius: '0.3rem' }}>
                                                <div
                                                    className={
                                                        this.state.rcsApprovedList ? "progress-bar bg-primary" :
                                                            this.state.rcsPendingList ? "progress-bar bg-warning" :
                                                                this.state.rcsInProcessList ? "progress-bar bg-info" :
                                                                    this.state.rcsRejectedList ? "progress-bar bg-danger" : "progress-bar bg-secondary"
                                                    }
                                                    role="progressbar"
                                                    style={{
                                                        width: `${this.state.rcsPendingList ? this.state.rcsPendingPercentage :
                                                            this.state.rcsApprovedList ? this.state.rcsApprovedPercentage :
                                                                this.state.rcsInProcessList ? this.state.rcsInProcessPercentage :
                                                                    this.state.rcsRejectedList ? this.state.rcsRejectedPercentage : 0
                                                            }%`
                                                    }}
                                                ></div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <span>
                                                    {
                                                        Number.isFinite(
                                                            parseFloat(
                                                                this.state.rcsPendingList ? this.state.rcsPendingPercentage :
                                                                    this.state.rcsApprovedList ? this.state.rcsApprovedPercentage :
                                                                        this.state.rcsInProcessList ? this.state.rcsInProcessPercentage :
                                                                            this.state.rcsRejectedList ? this.state.rcsRejectedPercentage : 0
                                                            )
                                                        )
                                                            ? parseFloat(
                                                                this.state.rcsPendingList ? this.state.rcsPendingPercentage :
                                                                    this.state.rcsApprovedList ? this.state.rcsApprovedPercentage :
                                                                        this.state.rcsInProcessList ? this.state.rcsInProcessPercentage :
                                                                            this.state.rcsRejectedList ? this.state.rcsRejectedPercentage : 0
                                                            ).toFixed(2)
                                                            : "0"
                                                    }%
                                                </span>

                                                {this.state.userType === "admin" && <FontAwesomeIcon onClick={this.handleRcsOnboardingClick} icon={faEye} className="ms-2 ml-2" style={{ cursor: "pointer" }} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* WhatsApp Onboarding Card */}
                                <div className="col-12 col-md-4">
                                    <div className="card h-100">
                                        <div className="card-header pb-0 border-bottom-0 d-flex justify-content-between align-items-center">
                                            <h5 className="mb-0">Whatsapp Onboarding</h5>
                                            <b style={{ color: "black" }}>
                                                {this.state.completeonboarding.length + this.state.pendingonboarding.length}
                                            </b>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex flex-wrap gap-2 mb-3">
                                                <span
                                                    className="badge"
                                                    style={{ backgroundColor: "#4ec9b0", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ pendingPercentageList: false, completedPercentageList: true })}
                                                >
                                                    Completed: {this.state.completeonboarding.length}
                                                </span>
                                                <span
                                                    className="badge ml-2"
                                                    style={{ backgroundColor: "#FF8000", color: "white", cursor: "pointer", padding: "6px 10px" }}
                                                    onClick={() => this.setState({ pendingPercentageList: true, completedPercentageList: false })}
                                                >
                                                    Pending: {this.state.pendingonboarding.length}
                                                </span>
                                            </div>

                                            <div className="progress mb-2" style={{ height: '6px', borderRadius: '0.3rem' }}>
                                                <div
                                                    className={
                                                        this.state.completedPercentageList ? "progress-bar bg-primary" :
                                                            this.state.pendingPercentageList ? "progress-bar bg-warning" : "progress-bar bg-secondary"
                                                    }
                                                    role="progressbar"
                                                    style={{
                                                        width: `${this.state.completedPercentageList ? this.state.completedPercentage :
                                                            this.state.pendingPercentageList ? this.state.pendingPercentage : 0
                                                            }%`
                                                    }}
                                                ></div>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <span>
                                                    {
                                                        Number.isFinite(
                                                            parseFloat(
                                                                this.state.completedPercentageList ? this.state.completedPercentage :
                                                                    this.state.pendingPercentageList ? this.state.pendingPercentage : 0
                                                            )
                                                        )
                                                            ? parseFloat(
                                                                this.state.completedPercentageList ? this.state.completedPercentage :
                                                                    this.state.pendingPercentageList ? this.state.pendingPercentage : 0
                                                            ).toFixed(2)
                                                            : "0"
                                                    }%
                                                </span>

                                                {this.state.userType === "admin" && <FontAwesomeIcon onClick={this.handleWPOnboardingClick} icon={faEye} className="ms-2 ml-2" style={{ cursor: "pointer" }} />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.isDialogOpen && (
                                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">

                                            <div className="modal-header">
                                                <h5 className="modal-title">Confirmation</h5>
                                                <button type="button" className="close" onClick={this.handleClose}>
                                                    <span>&times;</span>
                                                </button>
                                            </div>

                                            <div className="modal-body">
                                                <p>Are You Sure?</p>
                                            </div>

                                            <div className="modal-footer">
                                                <button
                                                    className="btn btn-info btn-sm mr-2"
                                                    onClick={this.handleClose}
                                                >
                                                    Close
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => this.userDisabled()}
                                                >
                                                    Yes
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )}



                            {/* Recent Users Table */}
                            {this.state.successMessage ? (
                                <div className={this.state.bgColor} role="alert">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="">{this.state.errorMessage}</div>
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="col-12 mb-4">
                                    <div className="card table-card">
                                        <div className="card-header">
                                            {/* Header Row */}
                                            <div className="row align-items-center">
                                                <div className="col-md-6 col-12 mb-2 mb-md-0">
                                                    <h6>Users List</h6>
                                                </div>
                                                <div className="col-md-6 col-12 d-flex justify-content-md-end justify-content-between align-items-center flex-wrap">
                                                    {this.state.userType === "admin" && (
                                                        <div className="d-flex align-items-center mb-2 mb-md-0">
                                                            <input
                                                                type="checkbox"
                                                                name="mmlite"
                                                                id="mmlite"
                                                                className="mr-2"
                                                                checked={this.state.mmliteChecked}
                                                                onChange={this.handleMmliteChange}
                                                            />
                                                            <label htmlFor="mmlite" className="mb-0 mr-3">
                                                                Mmlite
                                                            </label>
                                                        </div>
                                                    )}
                                                    <h6 className="mb-0">Total Record: {this.state.totalRecords || 0}</h6>
                                                </div>
                                            </div>

                                            {/* Filters Row */}
                                            <div className="row mt-3">
                                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                                    <div className="input-group">
                                                        <div className="input-group-text">
                                                            <FontAwesomeIcon icon={faSearch} />
                                                        </div>
                                                        <input
                                                            type="text"
                                                            onBlur={(e) => this.setState({ searchData: e.target.value })}
                                                            placeholder="Enter Username"
                                                            className="form-control"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                                    <div className="input-group">
                                                        <div className="input-group-text">
                                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                                        </div>
                                                        <input
                                                            type="date"
                                                            id="userSearchFromDate"
                                                            className="form-control"
                                                            value={this.state.userSearchFromDate}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    userSearchFromDate: e.target.value,
                                                                    successMessage: false,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                                    <div className="input-group">
                                                        <div className="input-group-text">
                                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                                        </div>
                                                        <input
                                                            type="date"
                                                            id="userSearchToDate"
                                                            className="form-control"
                                                            value={this.state.userSearchToDate}
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    userSearchToDate: e.target.value,
                                                                    successMessage: false,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                                    <button
                                                        onClick={() => this.searchUser()}
                                                        className="btn btn-info btn-sm btn-block"
                                                    >
                                                        Search User
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table */}
                                        {this.state.allUserList ? (
                                            <div className="card-body p-0">
                                                <div className="table-responsive" style={{ maxHeight: "450px" }}>
                                                    <table className="table table-hover mb-0">
                                                        <thead className="sticky-top bg-light">
                                                            <tr>
                                                                <th style={this.tableheadColor}>Action</th>
                                                                <th style={this.tableheadColor}>Email ID / Username</th>
                                                                <th style={this.tableheadColor}>Parent</th>
                                                                <th style={this.tableheadColor}>Credit</th>
                                                                <th style={this.tableheadColor}>Source</th>
                                                                <th style={this.tableheadColor}>Created Date / Expiry</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.allUserList
                                                                // .filter((item) => {
                                                                //     if (this.state.userType === "emp") {

                                                                //         const isSearching = this.state.searchData?.trim() !== "" ||
                                                                //             this.state.userSearchFromDate ||
                                                                //             this.state.userSearchToDate ||
                                                                //             this.state.mmliteChecked;

                                                                //         if (!isSearching) {
                                                                //             return item.mobile && item.mobile.trim() !== "";
                                                                //         }
                                                                //     }
                                                                //     return true;
                                                                // })
                                                                .map((item, i) => {
                                                                    const isAllowed = this.state.user_id === 1 || this.state.AdminEmail === item.parent_email;
                                                                    const isValid = (val) => val && val !== "null" && String(val).trim() !== "";
                                                                    const hasDesc = isValid(item.description);
                                                                    const hasProd = isValid(item.product);
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td>
                                                                                <>
                                                                                    <Link
                                                                                        className="mr-2"
                                                                                        to={`/admin/user-details/${item.id}/${item.user_type}`}
                                                                                        style={{ pointerEvents: "auto", opacity: 1 }}
                                                                                        // to={isAllowed ? `/admin/user-details/${item.id}/${item.user_type}` : "#"}
                                                                                        // style={{ pointerEvents: isAllowed ? "auto" : "none", opacity: isAllowed ? 1 : 0.5 }}
                                                                                        title="Edit"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                                    </Link>

                                                                                    <span
                                                                                        style={{
                                                                                            // cursor: isAllowed ? "pointer" : "not-allowed",
                                                                                            // opacity: isAllowed ? 1 : 0.5
                                                                                            cursor: "pointer",
                                                                                            opacity: 1
                                                                                        }}
                                                                                        className="mr-2"
                                                                                        title={item.is_active === 1 ? "Deactivate user" : "Activate user"}
                                                                                        onClick={() => {
                                                                                            // if (isAllowed) {
                                                                                            //     this.openDialog(item.is_active, item.id)
                                                                                            // }
                                                                                            this.openDialog(item.is_active, item.id)
                                                                                        }}
                                                                                    >
                                                                                        {item.is_active === 1 ? (
                                                                                            <FontAwesomeIcon color="green" icon={faUserLock} />
                                                                                        ) : (
                                                                                            <FontAwesomeIcon color="red" icon={faUserLock} />
                                                                                        )}
                                                                                    </span>

                                                                                    <span
                                                                                        style={{
                                                                                            // cursor: isAllowed ? "pointer" : "not-allowed",
                                                                                            // opacity: isAllowed ? 1 : 0.5
                                                                                            cursor: "pointer",
                                                                                            opacity: 1
                                                                                        }}
                                                                                        title="Login to this account"
                                                                                        onClick={() => {
                                                                                            // if (isAllowed) {
                                                                                            //     this.loginToUserAccount(
                                                                                            //         item.email,
                                                                                            //         item.password,
                                                                                            //         this.state.AdminEmail,
                                                                                            //         this.state.adminPassword
                                                                                            //     )
                                                                                            // }
                                                                                            this.loginToUserAccount(
                                                                                                item.email,
                                                                                                item.password,
                                                                                                this.state.AdminEmail,
                                                                                                this.state.adminPassword
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faSignInAlt} color="green" />
                                                                                    </span>
                                                                                </>

                                                                            </td>
                                                                            <td>
                                                                                <p className="m-0">{item.email}</p>
                                                                                <span className="d-block text-primary font-weight-bold small">
                                                                                    User ID : {item.id} , Mobile : {item.mobile}
                                                                                </span>
                                                                                <span className="d-block text-danger small">
                                                                                    Location : {item.country} ({item.city})
                                                                                </span>
                                                                                <span className="d-block small">
                                                                                    {this.state.userType === "admin" && <>MMLite : {item.mmlite === 1 ? "YES" : "NO"}</>}
                                                                                    {(hasDesc || hasProd) && (
                                                                                        <span
                                                                                            style={{ position: "relative", display: "inline-block", cursor: "pointer", marginLeft: "6px" }}
                                                                                            onClick={() => this.setState({ activeTooltipId: this.state.activeTooltipId === item.id ? null : item.id })}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faInfoCircle} color="#4ec9b0" />
                                                                                            {this.state.activeTooltipId === item.id && (
                                                                                                <div style={{
                                                                                                    position: "absolute",
                                                                                                    top: "125%",
                                                                                                    left: "0",
                                                                                                    backgroundColor: "#333",
                                                                                                    color: "white",
                                                                                                    padding: "6px 10px",
                                                                                                    borderRadius: "4px",
                                                                                                    fontSize: "12px",
                                                                                                    whiteSpace: "normal",
                                                                                                    zIndex: 1000,
                                                                                                    width: "220px",
                                                                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                                                                                    wordBreak: "break-word"
                                                                                                }}>
                                                                                                    {hasDesc && <div><strong>Description:</strong> {item.description}</div>}
                                                                                                    {hasProd && <div className="mt-1"><strong>Product:</strong> {item.product}</div>}
                                                                                                </div>
                                                                                            )}
                                                                                        </span>
                                                                                    )}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <strong className="text-capitalize">
                                                                                    {item.type} {item.parent_type}
                                                                                </strong>{" "}
                                                                                ({item.parent_name})
                                                                            </td>
                                                                            <td>
                                                                                {item.country_currency}:{" "}
                                                                                {parseFloat(item?.currency)?.toFixed(4)}
                                                                            </td>
                                                                            <td>
                                                                                Source:{" "}
                                                                                <strong className="text-capitalize">
                                                                                    {(() => {
                                                                                        const addedBy = item.added_by || "";
                                                                                        if (addedBy.includes("&")) {
                                                                                            const [first, second] = addedBy.split("&", 2);
                                                                                            return (
                                                                                                <>
                                                                                                    {first}
                                                                                                    {second ?
                                                                                                        <>
                                                                                                            <br />
                                                                                                            <span className="text-muted small text-capitalize">{second}</span>
                                                                                                        </> : null}
                                                                                                </>
                                                                                            );
                                                                                        } else {
                                                                                            return addedBy;
                                                                                        }
                                                                                    })()}
                                                                                </strong>{" "}

                                                                                <br />
                                                                                Plan :{" "}
                                                                                <strong className="text-capitalize text-primary">
                                                                                    {item.plan_name}
                                                                                </strong>
                                                                            </td>
                                                                            <td>
                                                                                {item.created}
                                                                                <br />
                                                                                {item.expiry}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="text-center">
                                                <div className="card-body">
                                                    <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                                    <p>No User Found </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>


                        </div>
                        {/* </div> */}

                    </main>
                    <AdminFooter />
                </div>
            </div>

        );
    }
}
export default UserManagement;